import { FeatureModule } from '@store/features/types';
import appointmentTypesReducer from './slice';

export const encounterTypesFeature: FeatureModule = {
  id: 'encounter-types',
  name: 'Encounter Types',

  dependencies: [], // No dependencies for now

  reducers: {
    appointmentTypes: appointmentTypesReducer, // Add the UI reducer
  },

  middleware: [], // RTK Query middleware is already registered at the store level via baseApi

  persistence: {
    enabled: false, // No persistence needed
  },

  // No cross-tab sync needed for now
  sync: {
    enabled: false,
  },

  setup: store => {
    console.log(`${encounterTypesFeature.name} feature initialized`);
  },

  cleanup: store => {
    console.log(`${encounterTypesFeature.name} feature cleaned up`);
  },
};
